export default "__VITE_ASSET__CEt1WYb4__"